import type { ReactNode } from "react";

export interface MenuSectionProps {
  title?: ReactNode;

  divider?: boolean;
  children: ReactNode;
}

export function MenuSection({ title, divider = false, children }: Readonly<MenuSectionProps>) {
  return (
    <>
      {divider && <div className="my-1 border-t border-border-subtle" />}
      {title && (
        <div className="px-3 pt-2 pb-1 [font:var(--type-eyebrow)] text-content-tertiary uppercase tracking-wide">
          {title}
        </div>
      )}
      {children}
    </>
  );
}
